import React from 'react';
import styled from 'styled-components';
import IllustrationSVG from 'images/Illustration.svg';
import { Colors } from 'modules/utils';
import Image from 'common/Image';

const IllustrationImg = styled.img`
	width: 400px;
`;

export const Illustration = () => <IllustrationImg src={IllustrationSVG} />;

export const Wrapper = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	height: 100vh;
`;

export const PageWrapper = styled.div`
	height: 100vh;
	background-color: ${Colors.LIGHT_GREY_2};
	padding: 30px;
`;

export const LogoWrapper = styled.div`
	position: absolute;
	top: 30px;
	left: 50px;
`;

export const TextWrapper = styled.div`
	margin-left: 50px;
	display: flex;
	flex-direction: column;
`;

export const BrowserItem = styled.div`
	margin-top: 18px;
	display: flex;
	align-items: center;
`;

export const ImageIcon = styled(Image)`
	width: 30px;
	margin-right: 18px;
`;
